export interface SignInFormValues {
  email: string;
  password: string;
}

export enum SignInFormErrorType {
  INCORRECT_EMAIL_OR_PASSWORD = 'incorrectEmailOrPassword',
}
